import { Box } from "@mui/material";

export const CustomIcon = (props) => {
  const { children } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "18px", // 원하는 크기
        height: "18px", // 원하는 크기
      }}
    >
      {children}
    </Box>
  );
};
